export default __webpack_public_path__ + "static/media/largestcompanies-1200-1606765438.9609f1d9.svg";